import { render, staticRenderFns } from "./addScraper.vue?vue&type=template&id=5f794c6a&"
import script from "./addScraper.vue?vue&type=script&lang=js&"
export * from "./addScraper.vue?vue&type=script&lang=js&"
import style0 from "./addScraper.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports